const hoverList = () => {
    const hoverListSections = document.querySelectorAll('.shopify-section.hover-list');
    const removeActiveClass = (object) => {
        object.classList.remove('active');
    };
    hoverListSections.forEach((section) => {
        const hoverTitles = section.querySelectorAll('[data-hover-title]');
        const hoverImages = section.querySelectorAll('[data-hover-image]');
        hoverTitles.forEach((title) => {
            title.addEventListener('mouseover', () => {
                hoverTitles.forEach((title) => {
                    removeActiveClass(title);
                });
                hoverImages.forEach((image) => {
                    removeActiveClass(image);
                });
                const itemNumber = title.getAttribute('data-hover-title');
                const matchingImage = section.querySelector('[data-hover-image="' + itemNumber + '"]');
                title.classList.add('active');
                matchingImage.classList.add('active');
            });
        });
    });
};
export { hoverList };
